import React from "react";
import styles from "./styles/PartnerStats.module.css";
import Icon from "../Home/common/Icon";

export default function PartnerStats() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.features}>
        <div className={styles.feature}>
          <span className={styles.featureIcon} aria-hidden="true"><Icon.Industrial /></span>
          <h3 className={styles.featureTitle}>Authorised Channel Partner</h3>
          <p className={styles.featureText}>
            We are an Authorised Channel Partner for Mitsubishi Electric Factory Automation products in India
          </p>
        </div>
        <div className={styles.feature}>
          <span className={styles.featureIcon} aria-hidden="true"><Icon.Certified /></span>
          <h3 className={styles.featureTitle}>Authorised Service Center</h3>
          <p className={styles.featureText}>
            For Mitsubishi Electric FA robots: Vertical, Horizontal, Micro Working & Ceiling Mounted
          </p>
        </div>
        <div className={styles.feature}>
          <span className={styles.featureIcon} aria-hidden="true"><Icon.Robot /></span>
          <h3 className={styles.featureTitle}>Mechatronic Solutions</h3>
          <p className={styles.featureText}>
            We provide Conveyor System, Servo Press, Laser Marking Workstations & SPM as part of mechatronic solutions
          </p>
        </div>
      </div>

      <div className={styles.stats}>
        <div className={styles.stat}>
          <span className={styles.statNumber}>2001</span>
          <span className={styles.statLabel}>ESTABLISHED</span>
        </div>
        <div className={styles.statDivider} aria-hidden="true" />
        <div className={styles.stat}>
          <span className={styles.statNumber}>60</span>
          <span className={styles.statLabel}>EMPLOYEES</span>
        </div>
        <div className={styles.statDivider} aria-hidden="true" />
        <div className={styles.stat}>
          <span className={styles.statNumber}>49</span>
          <span className={styles.statLabel}>PROJECTS</span>
        </div>
        <div className={styles.statDivider} aria-hidden="true" />
        <div className={styles.stat}>
          <span className={styles.statNumber}>38</span>
          <span className={styles.statLabel}>Delighted Partners</span>
        </div>
      </div>

      <div className={styles.ctaStrip}>
        <div className={styles.ctaInner}>
          <p className={styles.ctaText}>Looking for a First-Class Factory automation and robotics Partner?</p>
          <a href="/contact" className={styles.ctaBtn}>CONTACT US</a>
        </div>
      </div>
    </div>
  );
}
